// @ts-strict-ignore
import { extractThresholdIds } from 'flow/service/thresholds';
import type { Action, ObjectIdReverseTransformationMap, Threshold } from '../../../types';
import { reverseTransformMLAAttributeComponents } from '../rules/rules';
import { captureExceptionsToSentry } from '~/helpers/exceptionHandler';

export function reverseTransformJsonThresholdsToLegacyThresholds({
  thresholds,
  transformedActionsToLegacyActionsIdMap,
  jsonActions,
}: {
  thresholds: Record<string, Threshold>;
  transformedActionsToLegacyActionsIdMap: ObjectIdReverseTransformationMap;
  jsonActions: Record<string, Action>;
}) {
  const transformedLegacyThresholds = [];
  const transformedThresholdsToLegacyThresholdsIdMap = {};

  Object.entries(
    thresholds,
  ).forEach(([thresholdKey, thresholdValue], index) => {
    transformedThresholdsToLegacyThresholdsIdMap[thresholdKey] = index + 1;

    const action = jsonActions[thresholdValue.actionId];
    if (!action) {
      captureExceptionsToSentry(
        new Error('Action not found, skipping threshold for reverse transformation'),
        { thresholdValue, action },
      );
      return;
    }

    const thresholdIdsForAction = extractThresholdIds(action.rules);
    if (!thresholdIdsForAction.includes(thresholdValue.publicId)) {
      captureExceptionsToSentry(
        new Error('Threshold is not used by the action, skipping threshold for reverse transformation'),
        { thresholdValue, action },
      );
      return;
    }
    transformedLegacyThresholds.push({
      publicId: thresholdKey,
      id: index + 1,
      actionId: transformedActionsToLegacyActionsIdMap[thresholdValue.actionId],
      leftActionId: transformedActionsToLegacyActionsIdMap[thresholdValue.left.actionId],
      leftAttrComponents: reverseTransformMLAAttributeComponents({
        attributeFilterComponents: thresholdValue.left.attributeComponents,
        parentType: 'threshold_left',
      }) || [],
      leftAttrId: thresholdValue.left.attributeId,
      leftCategoryId: null, // this is a deprecated key but still sending null for dashboard backend
      operator: thresholdValue.operator,
      rightActionId: thresholdValue.right.actionId
        ? transformedActionsToLegacyActionsIdMap[thresholdValue.right.actionId]
        : null,
      rightAttrComponents: reverseTransformMLAAttributeComponents({
        attributeFilterComponents: thresholdValue.right.attributeComponents,
        parentType: 'threshold_right',
      }) || [],
      rightAttrId: thresholdValue.right.attributeId,
      rightAttrValue: thresholdValue.right.attributeValue,
      rightCRGId: thresholdValue.right.reasonCodeGroupId,
      rightCategoryId: null,
      rightTagActionSet: thresholdValue.right.leftTagActionResult,
    });
  });

  return {
    transformedLegacyThresholds,
    transformedThresholdsToLegacyThresholdsIdMap,
  };
}
